<script>
import {
  exportReportDetail,
  exportWorkOrderResult,
  exportOpportunityResult,
  getFeedbackExport
} from "@/service";

export default {
  data() {
    return {
      exported: false,
      url: null,
      error: false,
      job: null
    }
  },
  created () {
    const type = this.$route.query.type

    if(type){
        switch (type) {
            case 'wo':
                document.title = this.$t('工单管理')+this.$t('download')
                break;
          case 'auditing':
            document.title = '设备巡检服务报回访'+this.$t('download')
            break;
            case 'business':
                document.title = this.$t('商机管理')+this.$t('download')
                break;
            case 'maintain':
                document.title = this.$t('保养计划')+this.$t('download')
                break;
            default:
                break;
        }

    }
  },
  mounted() {
    const type = this.$route.query.type

    if(type){
        switch (type) {
            case 'wo':
                document.title = this.$t('工单管理')+this.$t('download')
                break;
          case 'auditing':
            document.title = '设备巡检服务报回访'+this.$t('download')
            break;
            case 'business':
                document.title = this.$t('商机管理')+this.$t('download')
                break;
            case 'maintain':
                document.title = this.$t('保养计划')+this.$t('download')
                break;
            default:
                break;
        }

    }
    const request_id = this.$route.params.request_id
    this.job = setInterval(() => {
      this.getUrl(request_id)
    }, 1000)
  },
  computed: {
    exportResultFunc() {
      if (this.$route.query.type === 'wo') {
        return exportWorkOrderResult
      }
      if (this.$route.query.type === 'auditing') {
        return getFeedbackExport
      }
      if (this.$route.query.type === 'business') {
        return exportOpportunityResult
      }
      return exportReportDetail
    }
  },
  methods: {
    // 获取文件下载信息
    getUrl(request_id) {
      this.exportResultFunc(request_id).then(res => {
        if (res.payload.status == 'ok') {
          clearInterval(this.job)
          this.exported = true
          this.url = res.payload.url
          window.location.href = this.url
        }
      }).catch(err => {
        console.log(err)
        this.error = true
        clearInterval(this.job)
      })
    }
  }
}
</script>
<template>
  <b-card class="d-flex justify-content-center align-items-center content">
    <b-card-body style="text-align: center">
      <div style="font-size: 5rem;">
        <span v-if="!exported" class="mdi mdi-spin mdi-dots-circle text-info"></span>
        <span v-else class="ri-checkbox-circle-line text-success"></span>
      </div>
      <p v-if="!exported">{{ $t('page.downloading') }}</p>
      <p v-else>{{ $t('page.fileDownloaded') }}</p>
      <p v-show="exported">{{ $t('page.ifNotDownload') }}，<span class="d-inline px-2 border-bottom"><b-link ref="downloadBtn" :href="url">{{ $t('page.clickHere') }}</b-link></span>{{ $t('page.startDownload') }}</p>
      <p v-if="error">{{ $t('page.errorOccurred') }}</p>
    </b-card-body>
  </b-card>

</template>
<style scoped>
.content {
  width: 500px;
  position: fixed;
  left: 0;
  right: 0;
  top: 30%;
  margin: auto;
}
</style>
